module.exports = __webpack_public_path__ + "static/media/KY.00718226.svg";